<template>
  <div class="carousel-item min-w-full">
    <div class="flex-shrink-0">
      <img
        :src="image"
        class="image cursor-pointer"
        @click="goNext"
        @touchend="goNext"
      />
    </div>

    <div class="text-block flex flex-col flex-auto p-7">
      <TypeHeading
        :variant="$options.Typography.Heading.HEADLINE"
        :weight="$options.Typography.Weights.STRONG"
        tag="p"
        class="mb-4"
      >
        {{ title }}
      </TypeHeading>
      <TypeBody
        :variant="$options.Typography.Body.MEDIUM"
        :weight="$options.Typography.Weights.REGULAR"
        tag="p"
        class="leading-7"
      >
        {{ body }}
      </TypeBody>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { TypeHeading, TypeBody, constants } from '@bambeehr/pollen';
import debounce from 'lodash/debounce';
const { Typography } = constants;

export default defineComponent({
  name: 'CarouselItem',
  components: { TypeHeading, TypeBody },
  Typography,
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const emitNext = () => {
      emit('next');
    };

    return {
      goNext: debounce(emitNext, 300),
    };
  },
});
</script>

<style scoped>
@media screen and (max-width: 870px) {
  .carousel-item {
    display: block;
  }
  .carousel-item .image {
    width: 100%;
    height: auto;
    max-height: 336px;
    object-fit: cover;
    object-position: center center;
  }
  .carousel-item .text-block {
    width: 100%;
  }
}
@media screen and (min-width: 871px) {
  .carousel-item {
    display: flex;
  }
  .carousel-item .image {
    max-height: 336px;
  }
  .carousel-item .text-block {
    width: 66%;
  }
}
</style>
